import React, { useState, useEffect, Fragment } from 'react'
import { MyStore } from '../../../../services/Store'
import { Route, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Container, Message, Search, Dropdown, Sidebar, Menu, Icon, Grid, Image, Segment, Header, Button, Form, Table, Modal, Checkbox } from 'semantic-ui-react'

 

import InviteUserModal from '../user/InviteUserModal'
import InviteNewUser from './InviteNewUser'

import moment from 'moment'

const DashboardMembers = (props) => {

    const [state, setState] = useState({
        showModal: false,
        imail: '',

     })


    const databaseRef = MyStore.database().ref();

    const [members, setMembers] = useState()
    const [invites, setInvites] = useState()
    const [emailInput, setEmailInput] = useState()
    const [oid, setOid] = useState()
    const [role, setRole] = useState({})
    const [roleKeys, setRoleKeys] = useState()
    const [imail, setImail] = useState({ email: '' })


    const inviteEmail = (e, { value }) => {
        // e.preventDefault();

        // setInviteE({ value })
        // console.log('inviteEmail -------- line 131')
        // console.log(props.gender)

        // console.log(value)
        setEmailInput(value)


        return value
        // props.handleChange('value')
        // props.gender = value


    }


    const roleOptions = [
        { key: 1, text: 'administrator', value: 'administrator' },
        { key: 2, text: 'clinician', value: 'clinician' },
        { key: 3, text: 'coordinator', value: 'coordinator' },
    ]

    const handleRoleChange = (value, key) => {
        roleKeys[key].role = value
        const currentChoice = {
            key: key,
            data: value
        }
    }


    const dropdownExampleSelection = (key) => (
        <Dropdown
            placeholder='Select a Role'
            clearable
            selection
            //   defaultValue={serviceOptions[0].text}
            options={roleOptions}
            onChange={(e, { value }) => handleRoleChange(value, key)} />)

    const _inviteEmail = (e) => {
        e.preventDefault();
        // console.log('================ line 80')

        // console.log(emailInput)
        // console.log(typeof (emailInput))
        setImail({ email: emailInput })
        setState({ imail: emailInput })

        MyStore.auth().fetchSignInMethodsForEmail(emailInput)
            .then((e) => {
                if (e == 'password') {
                    // console.log(e)
                    // console.log('QR CODE Sent.');
                    setState({ showModal: true })
                }
                else {
                    // console.log('user is not registered')
                }
            })
            .catch((error) => {
                // console.log(error.code);
                // console.log(error.message);
            });
    }



    const handleClick = (value) => {
        handleInvites(value)
    }

    const handleInvites = (key) => {
        // console.log(typeof(role))
        // console.log('--------------  handleInvites -----------------')

        if (roleKeys[key].role == "") {
            return
        }

        // console.log(invites[key])
        const tempInvite = invites[key]
        // console.log(roleKeys[key])
        // const tempInvite = invites[roles.key]

        const inivitedUser = {
            avatar: tempInvite.avatar,
            uid: tempInvite.uid,
            username: tempInvite.username,
            role: roleKeys[key].role,
            timestamp: Date.now(),
            momentTimestamp: moment().format('LLL')
        }
        // console.log(inivitedUser)

        // const testing =  databaseRef.child('groups/' + oid + '/testing')

        const currentGroup = databaseRef.child('groups/' + oid + '/members')

        currentGroup.child(inivitedUser.uid).set(inivitedUser);


        // console.log(inivitedUser)

        if (typeof (role) == 'object') {
            // console.log(' if(typeof(role) == object){')
            return
        }
        else if (typeof (role) == 'string' && role != '') {

            const currentGroup = databaseRef.child('groups/' + oid + '/members')

            currentGroup.on('value', snap => {
 
                let myArr = []
                // console.log('----------- function 01 -------------')
                for (const key in snap.val()) {

                }
                if (snap.val() != null) {
                    // this.setState({
                    //   files: myArr
                    // }) 
                    // console.log('if')
                }
                else {
                    // this.setState({
                    //   files: []
                    // })
                    // console.log('else')
                }

            })
        }
    }



    const displayMembers = () => {
        if (typeof (members) == 'object') {

            return (

                Array.from(members.keys()).map(key => (
                    <Table.Row key={key}  >
                        {/* <div>{setIcon(myfile.contentType)}</div> */}
                        <Table.Cell style={{ width: '1px' }} >
                            <Header as='h1' image>
                                <Image src={members[key].avatar} width="128" height="128"  ></Image>
                            </Header>
                        </Table.Cell>
                        <Table.Cell style={{ width: '25vh' }}> <b> {members[key].displayName}</b> <br></br>{members[key].username}  </Table.Cell>
                        <Table.Cell > <b>{members[key].role}</b></Table.Cell>
                    </Table.Row>
                ))
            )
        }
    }


    const displayInvites = () => {
        const currentInvite = []
        if (typeof (invites) == 'object') {
            return (
                Array.from(invites.keys()).map(key => (
                    <Table.Row key={key}  >
                        <Table.Cell style={{ width: '1px' }} >
                            <Header as='h1' image>
                                <Image src={invites[key].avatar} width="128" height="128"  ></Image>
                            </Header>
                        </Table.Cell>
                        <Table.Cell style={{ width: '25vh' }}> <b> {invites[key].displayName}</b> <br></br>{invites[key].username}  </Table.Cell>
                        <Table.Cell >


                            {dropdownExampleSelection(key)}

                            <Button icon='add user' size='large'
                                value={key}
                                onClick={() => handleClick(key)}
                            >
                            </Button>
                        </Table.Cell>
                    </Table.Row>
                ))
            )
        }
    }

    let cg = []
    const [currentGroup, setCurrentGroup] = useState({})
    const user = MyStore.auth().currentUser

    useEffect(() => {
        const id = props.oid
        setOid(id)
        // console.log(id)
        // console.log(props)


        // make sure to add an if statement if user is in this cadre
        MyStore.auth().onAuthStateChanged((user) => {
            if (user) {

                MyStore.database().ref().child(`/groups/${id}`).on('value', snap => {
                    // console.log(snap.val())
                    setCurrentGroup((snap.val()))

                    let myArr = []


                    for (const key in snap.val().members) {
                        myArr.push(Object.assign({}, snap.val().members[key]));
                    }
                    if (snap.val() != null) {
                        // users = myArr
                        cg = myArr
                        setMembers(cg)
                        // setState({myArr})
                    }



                    let inviteArr = []
                    let temp_roles = []

                    let count = 0
                    let roleKey = 0
                    for (const key in snap.val().invites) {
                        const keyObject = snap.val().invites[key]
                        keyObject['role'] = ''
                        keyObject['key'] = count++
                        inviteArr.push(Object.assign({}, (keyObject)));
                        temp_roles.push(Object.assign({}, ({ role: '', key: roleKey++, uid: snap.val().invites[key].uid })));
                    }
                    if (snap.val().invites != null) {
                        setInvites(inviteArr)
                        setRoleKeys(temp_roles)
                        // setState({myArr})
                    }


                });





            }

        })




    }, [])

    const handleCloseModal = () => () =>
    setState({ showModal: false })

    const modalAddMember = () => {

        if (state.showModal) {
            // SendInvite()
            return (
                <Modal basic closeOnDimmerClick={false} size='small' open
                    dimmer="blurring"
                >
                    {/* <Header content='Share URL or QR Code' /> */}
                    {/* <Header icon='mail' content='invitation sent' /> */}
                    <Modal.Header style={{ textAlign: "justfied" }} icon='mail'> <h1>Invitation sent to {imail.email} </h1> </Modal.Header>
                    <Modal.Content>


                        <Button color='green' inverted onClick={handleCloseModal()}>

                            <Icon name='checkmark' /> OK
                </Button>

                        <InviteNewUser oid={currentGroup.id} email={imail.email} oname={currentGroup.oname} ></InviteNewUser>
                    </Modal.Content>
                </Modal>


            )
        }



    }


    return (
        <Fragment>
            <Container>
                <br></br>
                <div>
                    <h1 style={{ textAlign: 'left', width: "20vh", height: "5vh" }} >Members</h1>
                </div>

                <br></br>
                <Form style={{ padding: '0px', margin: 'auto' }}>
                    <Form.Group >
                        <Form.Input value={emailInput} placeholder='member@company.com' style={{ textAlign: 'left', width: "45vh", height: "5vh" }}
                            onChange={inviteEmail}
                        />
                        <Form.Button style={{ height: "5vh", margin: 'auto' }} inverted color='blue' type="button"
                            onClick={_inviteEmail}>
                            invite
                                    </Form.Button>

                    </Form.Group>

                </Form>

                <Table textAlign='center'
                    style={{
                        background: "transparent",
                        border: "1px solid black",
                        boxShadow: "none",
                        padding: "0em 0em",
                        textAlign: 'justified',
                    }}  >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '1px' }} />
                            <Table.HeaderCell style={{ width: '25vh' }}><Header>Member</Header></Table.HeaderCell>
                            <Table.HeaderCell ><Header>Role</Header></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>


                        {displayMembers()}

                    </Table.Body>
                </Table>


                <Table textAlign='center'
                    style={{
                        background: "transparent",
                        border: "1px solid black",
                        boxShadow: "none",
                        padding: "0em 0em",
                        textAlign: 'justified',
                    }}

                >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '1px' }} />
                            <Table.HeaderCell style={{ width: '25vh' }}><Header>Member</Header></Table.HeaderCell>
                            <Table.HeaderCell ><Header>Role</Header></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>


                        {displayInvites()}
                    </Table.Body>
                </Table>

                {/* {TableExampleFullWidth()} */}

            </Container>

            {modalAddMember()}
        </Fragment>
    )

}


export default DashboardMembers